import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import StateMachine from "slotworks/state-machine/state-machine";
import AbstractButtonControl from "../abstract/abstract-button-control";

export default class AutoplayStartButtonControl extends AbstractButtonControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
    }

    public updateOptions(options: ControlOptions) {
        this.button.setEnabled(options.autoplays.currentValue > 0);

        super.updateOptions(options);
    }

    public setEnabled() {
        // Cancel default
    }

    protected onClick() {
        SmartUIFlags.set(SmartUIFlag.AUTO_SPIN, true);

        const options = new ControlOptions();
        this.onChange.dispatch(options);
        Services.autoplay.start();

        StateMachine.skip();
    }
}
